module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.noDefaultButton) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.toggleThisModal
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "o-modal",
    class: [_vm.name, {
      'o-modal--open': _vm.isThisModalOpen
    }]
  }, [_c('div', {
    staticClass: "o-modal__container",
    class: {
      'o-modal__container--wide': _vm.wide
    }
  }, [_c('div', {
    staticClass: "o-modal__close-button",
    on: {
      "click": _vm.toggleThisModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-modal__content"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8083b00e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 1761
// module chunks = 0